import { Component } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";
import { of } from "rxjs/observable/of";
import { StateService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import { CrewOkDialog } from "../shared/crew-ok-dialog.component";
import { map, tap, catchError } from "rxjs/operators";

@Component({
    selector: "password-operations",
    template: require('./password-operations.component.html')
})
export class PasswordOperations {

    constructor(
        private stateService: StateService,
        private dialog: MatDialog) { }

    private isLoadingSubject = new BehaviorSubject<boolean>(false);

    isLoading$ = this.isLoadingSubject.asObservable();

    message$: Observable<string> = of(null);

    performAction(
        action: () => Observable<any>,
        confirmationText: string,
        errorMessage: string): void {

        this.isLoadingSubject.next(true);
        this.message$ = action().pipe(
            map(() => {
                const dialogRef = this.dialog.open(CrewOkDialog);
                dialogRef.componentInstance.title = confirmationText;
                dialogRef.afterClosed().pipe(
                    tap(() => {
                        this.isLoadingSubject.next(false);
                        this.stateService.go("app.home");
                    })
                ).subscribe();
                return confirmationText;
            }),
            catchError(errorResponse => {
                this.isLoadingSubject.next(false);
                if (errorResponse.error?.Message) {
                    errorMessage += ": " + errorResponse.error.Message;
                }
                return of(errorMessage);
            })
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/password/password-operations.component.ts